export default Object.freeze({
  contact_us: "/ContactUs/",
  consulting_request: "/ConsultingRequest/",
  newsletter_subscriber: "/NewsletterSubscriber/",
  job_request: "/cv/",
  pages: {
    team: "/Team/",
    customers: "/Customer/",
    webpage: "/Webpage/$code/",
    page_title: "/PageTitle/$code/",
  },
  misc: {
    header_links: "/FooterLinks/",
    footer_links: "/FooterLinks/",
    social_link_by_title: "/social-link/?title=$title",
  },
  home: {
    social_links: "/SocialLinks/",
    product_groups: "/ProductGroup/",
    pinned_products: "/PinnedProduct/",
    top_news: "/News/",
  },

  news: {
    post_categories: "/PostCategory/",
    post_tags: "/Tag/",
    posts_list_all: "/PostList/?page=$page",
    posts_list_by_category: "/PostList/?category=$category&tag=$tag",
    posts_list_by_tag: "/PostList/?tag=$tag&category=$category",
    post_by_id: "/Post/$id/",
  },
  products: {
    list_all: "/Product/",
    by_id: "/Product/$id/",
  },
});
